import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=65f298dd&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"
import style0 from "./MasterForm.vue?vue&type=style&index=0&id=65f298dd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f298dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f298dd')) {
      api.createRecord('65f298dd', component.options)
    } else {
      api.reload('65f298dd', component.options)
    }
    module.hot.accept("./MasterForm.vue?vue&type=template&id=65f298dd&scoped=true", function () {
      api.rerender('65f298dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/investment-stategy-manager/MasterForm.vue"
export default component.exports